import { useEffect, useState } from "react";
import { getStudent } from "../../services/scpApi";
import { useSelector } from "react-redux";
import NotesEdit from "../../features/notes/NotesEdit";


const Notes = () => {

    const [student, setStudent] = useState({});
    const [currentPeriod, setCurrentPeriod] = useState();
    const selectedStudent = useSelector(state => state.portalSelected.selectedStudent);


    useEffect(() => {

        if (!selectedStudent || !selectedStudent.id) {
            setStudent({});
            setCurrentPeriod(undefined);
            return;
        }

        (async () => {
            try {
                const studentData = await getStudent(selectedStudent.id);
                setStudent(studentData);

            } catch (error) {
                console.log(error);
            }
        })();

    }, [selectedStudent])

    const handleAddNote = (updatedNotes) => {
        
        setStudent((prevStudent) => ({
            ...prevStudent,
            notes: updatedNotes,
        }));
    };

    return (
        <NotesEdit 
            notes={student.notes} 
            pupilId={student.id} 
            onAddNote={handleAddNote}
        /> 
    );
}
export default Notes;